import appAxios from "../../utils/appAxios";

export default {
    namespaced: true,
    state: {

    },
    auditDetailList: [],
    reportDetail: [],




    getters: {
        _getAuditListDetails: (state) => {
            return state.auditDetailList
        },
        _getSummary: (state) => {
            return state.summary
        },
        _getReportDetail: (state) => {
            return state.reportDetail
        }
    },

    actions: {
        async GET_REPORT_SUMMARY(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Report/GetAuditSummaryReport?auditId=${payload}`).then(Response => {
                    if (Response.data.Success) {
                        resolve(Response.data.Data)
                    }
                    else {
                        resolve(false)
                    }
                })
            })
        },

        async GET_REPORT_DEPARTMENT(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Report/GetAuditReportByDepartment?auditId=${payload}`).then(Response => {
                    if (Response.data.Success) {
                        resolve(Response.data.Data)
                    }
                    else {
                        resolve(false)
                    }
                })
            })
        },

        async UPDATE_ANSWER(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Audit/UpdateAuditPlanAnswer", payload).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Success)
                    }
                    else {
                        resolve(false)
                    }
                })
            })
        },


        async GET_REPORT_DETAILS({ state }, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/Report/GetAuditDetails?auditId=${payload}`).then((response) => {
                    if (response.data.Success) {
                        state.reportDetail = response.data.Data.Departments;
                        resolve(response.data.Data.Departments);
                    }
                    else (false)
                }).catch(() => resolve(false))
            })
        },

        async APPROVE_AUDIT(context, payload) {
            return new Promise(resolve => {
                appAxios.post(`/admin/Audit/Approve?auditId=${payload}`).then((response) => {
                    if (response.data.Success) {
                        resolve(response.data)
                    }
                    else {
                        resolve(false)
                    }

                })
            })
        },
        async GET_ANSWER_DETAIL(_, payload) {
            return new Promise(resolve => {
                appAxios.get(
                    `/admin/Audit/GetAuditPlanAnswerDetail?auditPlanAnswerId=${payload}`
                ).then((response) => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(false)
                    }

                })
            })
        },
        async REPORT_PDF(_, payload) {
            return new Promise(resolve => {
                appAxios
                    .get(`/admin/Report/AuditQuestionsToPdf?auditId=${payload}`, {
                        responseType: "blob",
                    }).then(response => {
                        resolve(response.data)
                    })
            })
        },
        async REMOVE_IMG(context, obj) {
            await appAxios.post(`/Admin/Audit/DeleteAuditPictures?pictureId=${obj.imgId}`).then((response) => {
                if (response.data.Success) {
                    context.dispatch("GET_REPORT_DETAILS", obj.auditId)
                }
            })
        },

        async CHECKLIST_ANALYSİS(_, payload) {
            return new Promise(resolve => {
                appAxios.post(`/Admin/Report/GetChecklistAnalysis`, payload).then((response) => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                })
            })

        }
    }
}